module.exports = __webpack_public_path__ + "img/131.580ee314.gif";